<script setup>
import { useModalStore } from '@/stores/ModalStore'
import { useI18n } from 'vue-i18n'
import { sanitizeHtml } from "@/utils/strings"

const modalStore = useModalStore()

const { t } = useI18n()
</script>

<template>
  <VDialog
    v-model="modalStore.confirmationDialog.visible"
    close-delay="1000"
    :max-width="modalStore.confirmationDialog.maxWidth"
    persistent
  >
    <VCard class="pa-2">
      <VCardTitle class="text-center confirmation-dialog-title">
        {{ modalStore.confirmationDialog.title }}
      </VCardTitle>
      <VCardText class="text-center">
        <div v-html="sanitizeHtml(modalStore.confirmationDialog.text)"></div>
      </VCardText>
      <VCardActions class="justify-center mt-2">
        <VBtn
          variant="outlined"
          color="secondary"
          @click="modalStore.handleConfirmation(false)"
        >
          {{ modalStore.confirmationDialog.cancelText || t('cancelText') }}
        </VBtn>
        <VBtn
          variant="flat"
          :color="modalStore.confirmationDialog.confirmColor || 'green'"
          @click="modalStore.handleConfirmation(true)"
        >
          {{ modalStore.confirmationDialog.confirmText || t('confirmText') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.confirmation-dialog-title {
  white-space: normal!important;
  line-height: 1.1rem!important;
}
</style>
